import { createContext } from 'react';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

type MyClubCardsLayoutContextValue = {
  defaultRarity: Rarity;
};

export const MyClubCardsLayoutContext =
  createContext<MyClubCardsLayoutContextValue>({
    defaultRarity: Rarity.limited,
  });
